import { CustomerData, OnboardingTypeEnum } from '@Store/index.ts';

export const getCustomerModel = (): CustomerData => {
  return {
    customerData: {
      onboardingTypeEnum: OnboardingTypeEnum.STANDARD,
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      ssn: '',
      birthDate: '',
      idCountry: '',
      idNumber: '',
      idExpirationDate: '',
      idGovNumber: '',
      customerAddressData: {
        city: '',
        state: '',
        line1: '',
        line2: '',
        postalCode: '',
        country: 'US',
        sameAsPrimary: false,
      },
      customerBusinessData: {
        ownershipPercent: 50,
        segment: '',
        naicsIndustry: '',
        businessName: '',
        ein: '',
        incorporationState: '',
      },
      businessAddressData: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: '',
        sameAsPrimary: false,
      },
    },
  };
};
